export default () => {
  const data = {
    event_name: 'click',
    button_name: 'immobiles',
    page_section: 'map_area',
    name_of_the_page_viewed: 'search_personal',
  };
  return data;
};
